<template>
  <div class="mobile-home">

    <!-- 视频播放弹窗 -->
    <cube-popup type="my-popup" ref="myPopup">
      <i class="cubeic-close close-btn" @click="hidePopup('myPopup')"></i>
      <video :src="play_address" width="100%" height="240" controls>Your browser does not support the video tag.</video>
    </cube-popup>

    <!-- 顶部渐变区域 -->
    <div class="hero-section">
      <div class="header-content">
        <div class="user-info">
          <div class="avatar">
            <img src="../assets/images/study.jpg" alt="user" />
          </div>
          <div class="greeting">
            <p class="welcome">欢迎回来</p>
            <p class="platform-name">上岸 · 学习课堂</p>
          </div>
        </div>
        <div class="header-actions">
          <span class="icon-bell">&#128276;</span>
        </div>
      </div>

      <!-- 搜索栏 -->
      <div class="search-bar">
        <span class="search-icon">&#128269;</span>
        <input
          class="search-input"
          v-model="searchKeyword"
          type="text"
          placeholder="搜索课程..."
        />
      </div>
    </div>

    <!-- 轮播图 -->
    <div class="slider-wrapper">
      <cube-slide :data="slider" :interval="5000">
        <cube-slide-item v-for="item in slider" :key="item.id">
          <router-link :to="`/`">
            <img :src="`/img/0${item}.jpg`" class="slider-img" />
          </router-link>
        </cube-slide-item>
      </cube-slide>
    </div>

    <!-- 继续观看 -->
    <div class="continue-card" v-if="lastVideo" @click="goToVideo(lastVideo)">
      <div class="continue-left">
        <span class="continue-label">上次看到</span>
        <p class="continue-name">{{ lastVideo.video_name }}</p>
        <span class="continue-btn">继续观看 &#9654;</span>
      </div>
      <div class="continue-right">
        <span class="continue-arrow">&#8250;</span>
      </div>
    </div>

    <!-- 分类列表 -->
    <div class="divHeight" v-if="filteredCatagory && filteredCatagory.length"></div>
    <section class="aui-flexView">
      <section class="aui-scrollView">
        <div class="aui-palace" v-if="filteredCatagory && filteredCatagory.length">
          <a
            href="javascript:;"
            style="border: 1px solid gray;margin: 5%;padding: 3%;box-shadow: 10px 10px 5px #888888;"
            class="aui-palace-grid"
            v-for="(item, index) in filteredCatagory"
            :key="index"
            :label="item.value"
          >
            <router-link :to="`/list/${item.id}`">
              <div class="aui-palace-grid-icon">
                <img src="../assets/images/icon-course-005.png" alt />
              </div>
              <div class="aui-palace-grid-text">
                <h2>{{ item.name }}</h2>
              </div>
            </router-link>
          </a>
        </div>
        <!-- 无搜索结果 -->
        <div class="search-empty" v-if="searchKeyword && filteredCatagory.length === 0">
          <p>未找到相关课程</p>
        </div>
      </section>
    </section>

    <!-- 加载状态 -->
    <div class="loading-state" v-if="loading">
      <cube-loading :size="30" style="color: #667eea"></cube-loading>
      <p>{{ loading }}</p>
    </div>
  </div>
</template>

<script>
import { set_click_rate } from "@/api/category";

export default {
  name: 'HomeMobile',
  props: {
    slider: { type: Array, required: true },
    catagory: { type: Array, default: () => [] },
    loading: { type: String, default: '' },
    lastVideo: { type: Object, default: null }
  },
  data() {
    return {
      play_address: "",
      searchKeyword: ""
    };
  },
  computed: {
    filteredCatagory() {
      if (!this.searchKeyword) return this.catagory;
      return this.catagory.filter(item =>
        item.name && item.name.includes(this.searchKeyword)
      );
    }
  },
  methods: {
    showPopup(refId, link, id) {
      this.$refs[refId].show();
      this.play_address = link;
      set_click_rate(id);
    },
    hidePopup(refId) {
      this.play_address = "";
      this.$refs[refId].hide();
    },
    goToVideo(video) {
      this.$router.push(`/video/${video.video_id}/1?categoryId=${video.category_id || ''}`);
    }
  }
};
</script>

<style>
@import "../assets/stytels/home-mobile.css";

.search-bar .search-input {
  flex: 1;
  background: transparent;
  border: none;
  outline: none;
  color: #fff;
  font-size: 13px;
  caret-color: #667eea;
}

.search-bar .search-input::placeholder {
  color: rgba(255, 255, 255, 0.4);
}

.search-empty {
  text-align: center;
  padding: 40px 20px;
  color: rgba(255, 255, 255, 0.5);
  font-size: 14px;
}

.continue-card {
  background: linear-gradient(135deg, #667eea, #764ba2);
  border-radius: 12px;
  margin: 12px 16px;
  padding: 14px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
}

.continue-left {
  flex: 1;
  min-width: 0;
}

.continue-label {
  font-size: 11px;
  color: rgba(255, 255, 255, 0.6);
}

.continue-name {
  font-size: 15px;
  font-weight: 600;
  color: #fff;
  margin: 4px 0 8px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.continue-btn {
  display: inline-block;
  font-size: 12px;
  color: #fff;
  background: rgba(255, 255, 255, 0.2);
  padding: 4px 12px;
  border-radius: 14px;
}

.continue-arrow {
  font-size: 24px;
  color: rgba(255, 255, 255, 0.6);
  margin-left: 8px;
}
</style>
